import type { typography } from "./common/fonts";
import type { colors } from "./themes/light/palette";

export enum THEME {
  light = "light",
  dark = "dark",
}

export interface CrmTheme {
  key: THEME;
  typography: typeof typography;
  colors: typeof colors;
}
